


const tools = [
  {
    name: 'AutoCAD',
    description: 'Industry-standard 2D/3D drafting software utilized for creating clean, perfectly scaled, and strictly layered DWG files.',
    icon: 'ri-pencil-ruler-2-line',
    color: 'from-red-500 to-red-600'
  },
  {
    name: 'Revit',
    description: 'Advanced BIM modeling utilized for comprehensive 3D spatial coordination and detailed structural representations.',
    icon: 'ri-building-3-line',
    color: 'from-blue-500 to-blue-600'
  },
  {
    name: 'Dialux',
    description: 'Professional lighting layout and photometric analysis software for optimal illumination planning.',
    icon: 'ri-lightbulb-line',
    color: 'from-yellow-400 to-yellow-500'
  },
  {
    name: 'SketchUp',
    description: '3D modeling software for creating detailed architectural designs, walkthroughs, and presentations.',
    icon: 'ri-shape-line',
    color: 'from-green-500 to-green-600'
  },
  {
    name: 'Unifi Design Center',
    description: 'Network infrastructure design and planning tool for enterprise-grade Wi-Fi deployments.',
    icon: 'ri-wifi-line',
    color: 'from-blue-600 to-blue-700'
  }
];

export default function ToolsSection() {
  return (
    <section className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Industry-Standard Technology Stack
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            We utilize the same advanced proposal building software your internal teams use, ensuring seamless integration. D-Tools, I-Point, Project 360, Portal.io (INDUSTRY SPECIFIC).
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {tools.map((tool) => (
            <div 
              key={tool.name}
              className="group p-8 rounded-2xl bg-gray-50 dark:bg-slate-800 border border-gray-100 dark:border-slate-700 hover:border-[#e18033] dark:hover:border-[#e18033] hover:shadow-xl transition-all duration-300"
            >
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${tool.color} flex items-center justify-center mb-6 shadow-lg transform group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${tool.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                {tool.name}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                {tool.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
